import { classNames } from '../../constants/recommendations';
import { conditionallyRenderAttrs } from '../../functions/renderer';

export const RecommendationSlide = (
  {
    recommendationId,
    sku,
    parentSku,
    name,
    url,
    image,
    price,
    deliveryDetails
  },
  slideIndex,
  isDYOSlider
) => `
<div
  class="${classNames.SLIDER_SLIDE}"
  ${conditionallyRenderAttrs(isDYOSlider, [
    { name: 'data-dy-product-id', value: sku }
  ])}
  ${conditionallyRenderAttrs(!isDYOSlider, [
    { name: 'data-sku', value: sku },
    { name: 'data-parent-sku', value: parentSku },
    { name: 'data-gtm-bind-click' },
    { name: 'data-position', value: slideIndex },
    { name: 'data-recommendation-id', value: recommendationId }
  ])}
>
  <a href="${url}">
    <span class="${classNames.IMAGE}">
      <img src="${image.src}" alt="${image.alt}" width="180" height="180">
    </span>
    <span class="${classNames.TITLE}">
      ${name}
    </span>
    <span class="${classNames.PRICE}">
      <span class="${price.isReduced ? classNames.PRICE_VAL_NEW : ''}">
        ${price.sellPrice}
      </span>
      ${
        price.showRegularPrice && price.originalPrice
          ? `<span class="${classNames.PRICE_VAL_OLD}">${
              price.originalPrice
            }</span>`
          : ''
      }
    </span>
    <span class="${classNames.DELIVERY_TIME} ${
  deliveryDetails.isFastDelivery ? classNames.DELIVERY_TIME_FAST : ''
}">
      ${deliveryDetails.deliveryTime}
    </span>
  </a>
</div>
`;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/components/RecommendationsSlider/recommendations-slide.js
 **/